import { type DietaryRestriction } from '@sg/graphql-schema';

import {
  type DietaryPreferencesTypes,
  INITIAL_DIETARY_PREFERENCES,
} from '../setup';
import { mergeKnownProperties } from './merge-known-properties';

// ─────────────────────────────────────────────────────────────────────────────

export function mergeRemoteDietaryPreferences(
  remotePreferences: DietaryRestriction[] | readonly DietaryRestriction[],
) {
  const preferences = [...remotePreferences].reduce<Preferences>(
    addPreference,
    {},
  );

  return mergeKnownProperties(INITIAL_DIETARY_PREFERENCES, preferences);
}

// ─────────────────────────────────────────────────────────────────────────────

function addPreference(
  preferences: Preferences,
  preference: DietaryRestriction,
) {
  return { ...preferences, [preference]: true };
}

type Preferences = Partial<DietaryPreferencesTypes>;
